module.exports = __webpack_public_path__ + "assets/paju-img-error.35b502aa.svg";